import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { ClickEventType, ParlorDetailProps } from "../../../types";
import { ColorSystemProps, GOI_WEB_URL } from "../../../constants";
import { numberToLocalString } from "../../../utils";

import { colors } from "../../../styles";

import { FullWidthButton } from "../../common/Buttons/FullWidthButton";
import { GoiBinsoParagraph } from "../GoiBinsoParagraph";

export function BinsoPriceTable({
  defaultParlor,
  mainColor,
}: {
  defaultParlor: ParlorDetailProps;
  mainColor: ColorSystemProps;
}) {
  const binsos = defaultParlor.binsos;

  return (
    <Stack>
      <TableContainer
        sx={{
          ["th"]: { background: mainColor.c300, color: "white" },
          ["td, tr, th"]: { textAlign: "center", border: "none" },
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                style={{ borderRadius: "10px 0 0 0" }}
                className="subtitle_14_b"
              >
                면적
              </TableCell>
              <TableCell
                style={{ borderRadius: "0 10px 0 0" }}
                className="subtitle_14_b"
              >
                빈소 가격(1일)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {binsos.map((res, i) => {
              return (
                <TableRow
                  style={{
                    background: i % 2 === 1 ? colors.gray50 : colors.white,
                  }}
                >
                  <TableCell
                    style={{
                      borderRadius: i === binsos.length - 1 ? "0 0 0 10px" : "",
                    }}
                    className="subtitle_14_sb"
                  >
                    {res.pyeong}평
                  </TableCell>
                  <TableCell
                    style={{
                      borderRadius: i === binsos.length - 1 ? "0 0 10px 0" : "",
                    }}
                    className="subtitle_14_sb"
                  >
                    {numberToLocalString(res.charge)}원
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
}
